import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { useSeo } from "../components/site/Seo";

export default function NotFound() {
  useSeo({ title: "404 — Page not found | Agni Shiksha" });
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center container-px">
      <div className="font-mono text-ember text-6xl font-bold">404</div>
      <h1 className="font-heading text-2xl font-bold mt-4">Page not found</h1>
      <p className="text-content-secondary mt-2 max-w-md">The page you're looking for doesn't exist or has moved.</p>
      <Button asChild className="btn-ember rounded-full mt-6"><Link to="/">Back to home</Link></Button>
    </div>
  );
}
